import { useState, useRef, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";

export const base_url = process.env.REACT_APP_API_URL;

const MatchOddsCricket = ({ user_phone, user_code }) => {
  const [formData, setFormData] = useState({
    min_bet: "100",
    max_bet: "500000",
    max_profit: "5000000",
    max_market_profit: "5000000",
    max_liability: "5000000",
    max_market_liability: "5000000",
    bet_delay: "0",
    commission_in: "0",
    commission_out: "0",
    game_name: "match_odds_cricket",
  });

  const formRef = useRef(null);

  // ✅ Fetch user settings when component loads
  useEffect(() => {
    const fetchUserSettings = async () => {
      try {
        const auth = localStorage.getItem("admin");
        const response = await axios.get(`${base_url}/get/api/webapi/admin/userSettingSubmit`, {
          params: { phone: user_phone, game_name: "match_odds_cricket" },
          headers: { Authorization: `${auth}` },
        });

        if (response.data.success && response.data.settings) {
          const settingsData = response.data.settings["match_odds_cricket"];

          if (settingsData) {
            const parsedSettings = JSON.parse(settingsData); // ✅ Convert string to JSON object
            setFormData((prev) => ({ ...prev, ...parsedSettings }));
          }
        }
      } catch (error) {
        console.error("Error fetching user settings:", error);
      }
    };

    fetchUserSettings();
  }, [user_phone, user_code]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    // event.preventDefault();

    try {
      const auth = localStorage.getItem("admin");

      // ✅ Ensure `phone` and `game_name` are included in formData
      const updatedFormData = {
        ...formData,
        phone: user_phone, // ✅ Include phone
        user_code: user_code, // ✅ Include phone
        game_name: "match_odds_cricket", // ✅ Include game_name
      };

      const response = await axios.post(`${base_url}/api/webapi/admin/userSettingSubmit`, updatedFormData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${auth}`,
        },
      });

      if (response.data.success) {
        toast.success("Form submitted successfully!");
      } else {
        toast.error("Submission failed!");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form");
    }
  };


  return (
    <form ref={formRef} id="submit_user_setting" className="form-ui">
      <input type="hidden" name="phone" value={user_phone} />
      <input type="hidden" name="user_code" value={user_code} />
      <input type="hidden" name="game_name" value="match_odds_cricket" />

      <h4>MATCH_ODDS (Cricket)</h4>

      <div className="row">
        <div className="input-field col s4 m3">
          <input placeholder="Min Bet" name="min_bet" type="text" value={formData.min_bet} onChange={handleChange} />
          <label className="active">Min Bet</label>
        </div>
        <div className="input-field col s4 m3">
          <input placeholder="Max Bet" name="max_bet" type="text" value={formData.max_bet} onChange={handleChange} />
          <label className="active">Max Bet</label>
        </div>
        <div className="input-field col s4 m3">
          <input placeholder="Max Profit" name="max_profit" type="text" value={formData.max_profit} onChange={handleChange} />
          <label className="active">Max Profit</label>
        </div>
        <div className="input-field col s4 m3">
          <input placeholder="Max Market Profit" name="max_market_profit" type="text" value={formData.max_market_profit} onChange={handleChange} />
          <label className="active">Max Market Profit</label>
        </div>
        <div className="input-field col s4 m3">
          <input placeholder="Max Liability" name="max_liability" type="text" value={formData.max_liability} onChange={handleChange} />
          <label className="active">Max Liability</label>
        </div>
        <div className="input-field col s4 m3">
          <input placeholder="Max Market Liability" name="max_market_liability" type="text" value={formData.max_market_liability} onChange={handleChange} />
          <label className="active">Max Market Liability</label>
        </div>
        <div className="input-field col s4 m3">
          <input placeholder="Bet Delay" name="bet_delay" type="text" value={formData.bet_delay} onChange={handleChange} />
          <label className="active">Bet Delay</label>
        </div>
        <div className="input-field col s4 m3">
          <input placeholder="Commission In" name="commission_in" type="text" value={formData.commission_in} onChange={handleChange} />
          <label className="active">Commission In</label>
        </div>
        <div className="input-field col s4 m3">
          <input placeholder="Commission Out" name="commission_out" type="text" value={formData.commission_out} onChange={handleChange} />
          <label className="active">Commission Out</label>
        </div>
      </div>

      <button onClick={handleSubmit} type="submit" className="waves-effect waves-light btn white-text" style={{ fontWeight: 800 }}>
        Update
      </button>

    </form>
  );
};

export default MatchOddsCricket;
